import React from 'react'

interface RecruitmentLimitToastErrorProps {
    formattedLimitCount: string
    formattedLimitPeriod: string
}

export const RecruitmentLimitToastError: React.FC<RecruitmentLimitToastErrorProps> = ({
    formattedLimitCount,
    formattedLimitPeriod,
}) => {
    return (
        <>
            <header style={{ fontSize: '16px', fontWeight: 700, lineHeight: '22px' }}>
                Превышен лимит
            </header>
            <div>
                Можно создать не больше {formattedLimitCount} за {formattedLimitPeriod}. Обратитесь
                к своему менеджеру.
            </div>
        </>
    )
}
